'use strict';

const fontFace = require('./font-face.cjs');
const _import = require('./import.cjs');
const media = require('./media.cjs');
const page = require('./page.cjs');
const supports = require('./supports.cjs');

const atrule = {
    'font-face': fontFace,
    'import': _import,
    media,
    page,
    supports
};

module.exports = atrule;
